import {
  browserTracingIntegration,
  replayIntegration,
  init as sentryInit,
} from '@sentry/react-router'
import posthog from 'posthog-js'
import { startTransition, StrictMode, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { HydratedRouter } from 'react-router/dom'

if (import.meta.env.PROD) {
  sentryInit({
    dsn: 'https://e212c96569e7f67ed34ace3534e7917e@o4506402832973824.ingest.us.sentry.io/4508897345798144',
    integrations: [browserTracingIntegration(), replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

function PosthogInit() {
  useEffect(() => {
    if (import.meta.env.PROD) {
      posthog.init('phc_JgAjW3xHh8YNqPGFQDi5imHRDIMapbrNOUNll0TJyZk', {
        api_host: 'https://us.i.posthog.com',
        person_profiles: 'identified_only',
      })
    }
  }, [])

  return null
}

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
      <PosthogInit />
    </StrictMode>
  )
})
